<template lang="pug">
  .industry#industry(v-if="isshow")
    el-cascader(
      :size="cascaderSize"
      :options="options"
      clearable
      ref="industry"
      style="width: 100%"
      v-model="industryValue"
      :props="industryProps"
      @change="addIndustry"
      @focus="showPopper"
      :disabled="disabled"
      filterable
      :popper-class="nonePopper")
    el-tag(
      v-for="(industry, index) in industries"
      :key="index"
      @close="removeIndustry(index)"
      closable) {{industry}}
  .industry#industry(v-else)
    el-cascader(
      style='width:250px'
      v-model="industryId"
      :size="GLOBAL.SIZE_OF_INPUTBOX"
      @change="changeIndustry"
      :options="options"
      :props="{ checkStrictly: true, value:'id', label:'name' }"
      clearable)
</template>
<script>
/**
 * Frost Industry 通用组件
 * Django 2018/11/20
 * 取自Frost Industry And Labels通用系统中的行业数据
 * industry id用于存储真实值，industry name 用于显示行业名称
 * 双重变量的同时动态绑定,v-model 绑定id
 * v-bind:name 和v-on:change 用于绑定行业名称，用法如下：
 * FrostIndustry(v-model="single.industryId" v-bind:name="single.industry" v-on:change="single.industry = $event")
 */
import { getASharesIndustryCatelogue, getHKSharesIndustryCatelogue } from '@vestleader/industrycatelogue'

function getCascaderObj (val, opt) {
  return val.map(function (value, index, array) {
    for (var itm of opt) {
      if (itm.id === value) {
        opt = itm.children
        return itm.name
      }
    }
    return null
  })
}
export default {
  name: 'ForstIndustry',
  props: {
    value: { type: Array },
    name: { type: Array },
    size: String,
    industryName: Array,
    isshow: { type: Boolean, default: true },
    disabled: { type: Boolean }
  },
  // model: {
  //   prop: 'value',
  //   event: 'input'
  // },
  data () {
    return {
      industryProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        expandTrigger: 'hover',
        checkStrictly: true
      },
      options: [], // 备选的行业信息，来自于沙利文统一行业API
      industryValue: [], // 临时变量，存储选择过程中的行业
      industryIds: [], // 选中的行业ID
      industries: [], // 选中行业的名称
      cascaderSize: '',
      industryId: [], // v-else中使用的值
      nonePopper: ''
    }
  },
  watch: {
    size (n, o) {
      this.cascaderSize = n
    },
    name (n, o) {
      this.industries = n
    },
    value (n, o) {
      this.industryIds = n
    },
    industryName (val) {
      if (val) {
        this.industries = val
      }
    },
    industryId: function (newVal, oldVal) {
      this.$emit('industryId', newVal)
    }
  },
  created () {
    if (this.size) this.cascaderSize = this.size

    const ACate = getASharesIndustryCatelogue()
    const HKCate = getHKSharesIndustryCatelogue()

    this.options = [{ id: 1, children: ACate, name: 'A股' }, { id: 2, children: HKCate, name: '港股' }]

    this.industryIds = this.value ? this.value : []
    this.industries = this.name ? this.name : []
  },
  methods: {
    showPopper () {
      this.nonePopper = ''
    },
    removeIndustry (index) {
      this.industryIds.splice(index, 1)
      this.industries.splice(index, 1)
      this.$emit('input', this.industryIds)
      this.$emit('change', this.industries)
      this.$emit('handleSaveIndustry', this.industries)
    },
    addIndustry () {
      // this.nonePopper = 'show-popper'
      if (this.industryValue.length === 0) return
      this.industryIds.push(this.industryValue)
      // this.industries.push(this.$refs.industry.currentLabels.join(' / '))
      const res = getCascaderObj(this.industryValue, this.options)
      this.industries.push(res.join('/').trim())
      this.$emit('input', this.industryIds)
      this.$emit('change', this.industries)
      this.$emit('handleSaveIndustry', this.industries)
      this.industryValue = []
      this.$forceUpdate()
    },
    changeIndustry () {
      this.$emit('changeIndustryId', this.industryId)
    }
  }
}
</script>
<style>
#industry .el-tag {
  margin: 0 10px 10px 0;
}
/* 这个类不能被重复使用 */
.show-popper {
  display: none !important;
}
</style>
